import { render } from "./HowItWorks.vue?vue&type=template&id=925e2e8c"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"
script.render = render

export default script